import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import Navbar from "@/components/Navbar";
import { Logo } from "@/components/Logo";
import { ShieldAlert, ScrollText } from "lucide-react";

const TERMS = [
  "The Savings Card is intended for the exclusive use of the cardholder, their spouse, and children aged 18 and under living in the same household. It is non-transferable and may not be shared, resold, or gifted.",
  "Any violation may result in cancellation of the Savings Card code without refund.",
  "We reserve the right to investigate and take appropriate action in cases of suspected misuse, including code cancellation.",
  "The card cannot be sold or turned into cash, has no cash value, can't be combined with other offers, and is valid only for the cardholder and immediate family. While the cardholder is present, non-family members may stay in the same room up to the hotel's occupancy limit.",
];

const Terms = () => {
  return (
    <div className="min-h-screen bg-[var(--ir-bg)] text-[var(--ir-text)]" data-testid="terms-page">
      <Navbar />
      <main className="max-w-4xl mx-auto px-6 pt-40 pb-24">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
          <span className="inline-flex items-center gap-2 text-xs tracking-[0.3em] uppercase text-[var(--ir-orange)] font-semibold">
            <ScrollText className="w-4 h-4" /> Terms & Compliance
          </span>
          <h1 className="font-display text-4xl sm:text-5xl mt-4 leading-tight text-[var(--ir-text)]">Code Usage &amp; Compliance</h1>
          <p className="text-[var(--ir-muted)] mt-5 leading-relaxed">
            The following terms govern the use of your Image Reservations Savings Card and PIN number.
          </p>
        </motion.div>

        <div className="mt-10 rounded-xl border border-[var(--ir-orange)]/30 bg-[var(--ir-orange)]/5 p-6 sm:p-7 flex items-start gap-4" data-testid="terms-do-not-share">
          <ShieldAlert className="w-6 h-6 text-[var(--ir-orange)] shrink-0 mt-0.5" />
          <p className="text-[var(--ir-text)] leading-relaxed">
            Do not share your card/PIN number with anyone. Any violation of this rule will invalidate your card/PIN number and cancel all reservations made using this subscription program.
          </p>
        </div>

        <ol className="mt-10 space-y-6">
          {TERMS.map((t, i) => (
            <li key={i} className="flex items-start gap-4" data-testid={`terms-item-${i + 1}`}>
              <div className="shrink-0 w-9 h-9 flex items-center justify-center rounded-full bg-[var(--ir-blue)] text-white font-display font-semibold">{i + 1}</div>
              <p className="text-[var(--ir-text)] leading-relaxed pt-1">{t}</p>
            </li>
          ))}
        </ol>

        <div className="mt-14">
          <Link to="/" className="text-[var(--ir-blue)] font-medium hover:underline" data-testid="terms-back-link">← Back to home</Link>
        </div>
      </main>

      <footer className="bg-white border-t border-[var(--ir-border)]">
        <div className="max-w-7xl mx-auto px-6 py-12 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
          <Logo size="sm" />
          <div className="text-[var(--ir-muted)] text-sm">© {new Date().getFullYear()} Image Reservations. All rights reserved.</div>
        </div>
      </footer>
    </div>
  );
};

export default Terms;
